import {Tag} from 'antd';

const defCode = `
import { McHorBarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State defOption: Options = new Options({
      title: {
        show: true,
        text: '基础属性',
        right: 20,
        top: 30
      },
      xAxis:{
        data:['周一','周二','周三','周四','周五','周六','周日']
      },
      yAxis:{
        name:'温度'
      },
      series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
      ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`

const changeCode = `
import { McHorBarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
   @State defOption: Options = new Options({
    title: {
      show: true,
      text: '更新数据',
      right: 20,
      top: 30
    },
    xAxis: {
        data: ['周一','周二','周三','周四','周五','周六','周日']
    },
    yAxis: {
        name:'温度'
    },
    series: [
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
    ]
  })
  aboutToAppear() {
    setTimeout(() => {
      // 使用Option实例对象的setVal方法来实现，修改什么属性就传什么
      this.defOption.setVal({
        series: [
          {
            name:'最高气温',
            data:[110, 110, 150, 130, 102, 130, 210]
          }
        ]
      })
    }, 2000)
  }
  build() {
    Row() {
      McHorBarChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`
const xAxisCode = `
import { McHorBarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State xAxisOption: Options = new Options({
    title: {
      show: true,
      text: 'xAxis属性配置',
      right: 20,
      top: 30
    },
    xAxis:{
        axisLine: { // 轴线样式
            show: true, // 是否显示
            lineStyle: {
                color: '#ccc',
                width: 2
            }
        },
        axisTick: { // 刻度线配置
            show: true, // 是否显示
            length: 4, // 刻度的长度
            lineStyle: {
                color: '#ccc', // 刻度线颜色
                width: 2 // 刻度线宽度
            }
        },
        axisLabel: {  // x轴文本标签样式
            color: '#bf19ff',
            fontSize: 22,
            overflow: 'truncate',
            formatter: (name: string, index: number) => { // 自定义文本标签
                return name
            },
        },
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    yAxis:{
        name:'温度'
    },
    series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.xAxisOption
      })
    }
    .height('50%')
  }
}
`

const yAxisCode = `
import { McHorBarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State yAxisOption: Options = new Options({
    title: {
      show: true,
      text: 'yAxis属性配置',
      right: 20,
      top: 30
    },
    xAxis:{
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    yAxis:{
        name: '单位/摄氏度', // 坐标名称
        nameTextStyle: { // 名称样式
          color: '#000'
        },
        nameGap: 10,
        axisLine: { // 轴线样式
          show: true, // 是否显示
          lineStyle: {
            color: '#ccc',
            width: 2
          }
        },
        axisTick: { // 刻度线配置
          show: false
        },
        splitLine: { // 坐标轴中的分隔线。
           show: false
        },
        axisLabel: {  // x轴文本标签样式
          color: '#bf19ff',
          formatter: (name: string, index: number) => { // 自定义文本标签
            return name + '°C'
          }
        }
    },
    series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.yAxisOption
      })
    }
    .height('50%')
  }
}
`

const legendCode = `
import { McHorBarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State legendOption: Options = new Options({
      title: {
          show: true,
          text: 'legend属性',
          right: 20,
          top: 30
      },
      xAxis:{
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
      },
      legend: {
        show: true,
        left : 20,
        top: 30,
        itemGap: 10,
        itemTextGap: 10,
        itemWidth: 8,
        itemHeight: 8, // 图例标记的图形高度。
        textStyle: {
          color: '#000',
          fontWeight: 'normal',
          fontFamily: 'sans-serif',
          fontSize: 24
        }
      },
      series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
      ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const tooltipCode = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
      title: {
          show: true,
          text: 'tooltip属性',
          right: 20,
          top: 30
      },
      xAxis:{
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
      },
      tooltip: {
        borderColor: '#f72659f5',
        borderWidth: 1,
        backgroundColor: '#fff',
        textStyle: { // 文本样式配置
          color: '#000'
        }
      },
      series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
      ]
  })

  build() {
    Row() {
      McHorBarChart({
        options: this.tooltipOption
      })
    }
    .height('50%')
  }
}
`


const tooltipCustomCode = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
      title: {
          show: true,
          text: '自定义tooltip属性',
          right: 20,
          top: 30
      },
      xAxis:{
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
      },
      series:[
        {
          name:'最高气温',
          data:[11, 11, 15, 13, 12, 130, 10]
        }
      ]
  })

  @Builder
  customTooltip($$: chartInterface.InterfaceObj) {
    if ($$.tooltipInfo.title) {
      Text($$.tooltipInfo.title)
    }
    ForEach($$.tooltipInfo.data,
       (item: chartInterface.InterfaceObj, index) => {
      Text(item.name + '：' + item.num)
    })
  };

  build() {
    Row() {
      McHorBarChart({
        options: this.tooltipOption,
        customTooltip: this.customTooltip
      })
    }
    .height('50%')
  }
}
`


const seriesCode = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  const commonSeries = {
      backgroundBar: {
        show: true
      },
      label: {
        show: true,
        color: '#fffa6262',
        fontWeight: '600',
        fontFamily: 'sans-serif',
        fontSize: 30,
        formatter: (params: chartInterface.InterfaceObj,
         index: number): string => {
          return params.name
        }
      }
  }
  @State seriesOption: Options = new Options({
      title: {
          show: true,
          text: 'series属性',
          right: 20,
          top: 30
      },
      xAxis:{
        data: ['周一','周二','周三','周四','周五','周六','周日'] // 数据
      },
      series:[
        {
          name:'最高气温',
          color: '#ff2659f5', // 自定义颜色
          ...commonSeries,
          data:[11, 11, 15, 13, 12, 130, 10] // 数据
        },
        {
          name:'最高气温',
          ...commonSeries,
          data:[-11, -11, -15, -13, -12, -130, -10] // 数据
        }
      ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.seriesOption
      })
    }
    .height('50%')
  }
}
`

const seriesGradientOption = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State seriesGradientOption: Options = new Options({
    title: {
      show: true,
      text: '渐变柱状图',
      right: 20,
      top: 30
    },
    xAxis:{
      data: ['周一','周二','周三','周四','周五','周六','周日',
       '周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    series:[
      {
        name:'最高气温',
        color: '#53e075', // 自定义颜色
        
        gradient: {
          color: ['#53e075', '#7953e075']
        },
        data: [30, 31, 35, 31, 28, 31, 31,
         29, 30, 39, 18, 28, 37, 19] // 数据
      },
      {
        name:'最低气温',
        barStyle: { // 柱子的样式配置
          color: '#fa6262'
        },
        backgroundBar: {
          show: true
        },
        label: {
          show: true,
          color: '#fa6262',
          fontWeight: '600',
          fontFamily: 'sans-serif',
          position: '',
          fontSize: 30,
          formatter: 'seriesLabel'
        },
        gradient: {
          color: ['#fa6262', '#83fa6262']
        },
        data: [11, 11, 15, 13, 12, 13, 10,
         11, 11, 15, 13, 12, 13, 10] // 数据
      }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.seriesGradientOption
      })
    }
    .height('50%')
  }
}
`

const seriesRadiusOption = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State seriesRadiusOption: Options = new Options({
    title: {
      show: true,
      text: '圆角模式',
      right: 20,
      top: 30
    },
    xAxis:{
      data: ['周一','周二','周三','周四','周五','周六','周日',
       '周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    series:[
      {
        name:'最高气温',
        color: '#53e075', // 自定义颜色
        barStyle: { // 柱子的样式配置
          width: 10,
          borderRadius: [0, 4, 4]
        },
        gradient: {
          color: ['#53e075', '#7953e075']
        },
        data: [30, 31, 35, 31, 28, 31, 31,
         29, 30, 39, 18, 28, 37, 19] // 数据
      },
      {
        name:'最低气温',
        barStyle: { // 柱子的样式配置
          color: '#fa6262',
          borderRadius: [0, 4, 4]
        },
        gradient: {
          color: ['#fa6262', '#83fa6262']
        },
        data: [11, 11, 15, 13, 12, 130, 100,
         11, 11, 15, 13, 12, 130, 100] // 数据
      }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.seriesRadiusOption
      })
    }
    .height('50%')
  }
}
`

const stackSeriesOption = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State stackSeriesOption: Options = new Options({
    title: {
      show: true,
      text: '堆叠模式',
      right: 20,
      top: 30
    },
    xAxis:{
      data: ['周一','周二','周三','周四','周五','周六','周日',
       '周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    series:[
      {
        name:'最高气温',
        stack: 'name',
        label: {
          position: 'center',
          offset: [0, 0],
          color: '#fff'
        },
        data: [30, 31, 35, 31, 28, 31, 31,
         29, 30, 39, 18, 28, 37, 19] // 数据
      },
      {
        name:'最低气温',
        barStyle: { // 柱子的样式配置
          color: '#fa6262'
        },
        label: {
          position: 'center',
          offset: [0, 0],
          color: '#fff'
        },
        stack: 'name',
        data: [11, 11, 15, 13, 12, 130, 100,
         11, 11, 15, 13, 12, 130, 100] // 数据
      }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.stackSeriesOption
      })
    }
    .height('50%')
  }
}
`

const dataZoomCode = `
import { McHorBarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State dataZoomOption: Options = new Options({
    xAxis:{
      data: ['周一','周二','周三','周四','周五','周六','周日',
       '周一','周二','周三','周四','周五','周六','周日'] // 数据
    },
    dataZoom: {
      show: true,
      start: 3,
      end: 8
    },
    series: [
      {
        name: '最高气温',
        data: [11, 110, 15, 130, 12, 130, 10]
      },
      {
        name: '最低气温',
        data: [150, 13, 120, 101, 11, 13, 100]
      }
    ]
  })
  build() {
    Row() {
      McHorBarChart({
        options: this.seriesOption
      })
    }
    .height('50%')
  }
}
`

const columns = [
    {
        title: '名称',
        width: 200,
        dataIndex: 'name',
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color="#2db7f5">{!text ? '否' : '是'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];

const commonData = [
    {
        name: 'grid',
        describe: '直角坐标系内绘图网格',
        type: 'Object',
        defVal: '{}',
        state: '',
        remarks: '用于设置上下左右四个边距，替代历史的cPaddingL、cPaddingT、cPaddingR、cPaddingB四个属性，不过最新版本也会兼容旧的使用方式',
        children: [
            {
                name: 'left',
                describe: '图表内容区距离左侧位置',
                type: 'String | Number',
                defVal: '10%',
                remarks: '',
            },
            {
                name: 'right',
                describe: '图表内容区距离右侧位置',
                type: 'String | Number',
                defVal: '8%',
                remarks: '',
            },
            {
                name: 'top',
                describe: '图表内容区距离顶部位置',
                type: 'String | Number',
                defVal: '40',
                remarks: '',
            },
            {
                name: 'bottom',
                describe: '图表内容区距离底部位置',
                type: 'String | Number',
                defVal: '30',
                remarks: '',
            }
        ]
    },
    {
        name: 'cPaddingT',
        describe: '图表内容区距离顶部位置',
        type: 'Number',
        defVal: '20',
        state: 'del',
        remarks: '',
    },
    {
        name: 'cPaddingL',
        describe: '图表内容区距离左侧位置',
        type: 'Number',
        defVal: '30',
        state: 'del',
        remarks: '',
    },
    {
        name: 'cPaddingB',
        describe: '图表内容区距离底部位置',
        type: 'Number',
        defVal: '30',
        state: 'del',
        remarks: '',
    },
    {
        name: 'cPaddingR',
        describe: '图表内容区距离右侧位置',
        type: 'Number',
        defVal: '30',
        state: 'del',
        remarks: '',
    },
    {
        name: 'color',
        describe: '调色盘颜色列表',
        type: 'String[]',
        defVal: "['#296DFF', '#ff5495fd', '#ff1acffd', '#ff72e4fd', '#7B72F7', '#F85758', '#FFBF29', '#D1E9F9', '#F5FAFC', '#5A657A']",
        remarks: '',
    },
    {
        name: 'title',
        describe: '标题组件与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        children: [
            {
                name: 'show',
                describe: '控制标题显示与隐藏',
                type: 'Boolean',
                defVal: 'true',
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                name: 'text',
                describe: '主标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'subtext',
                describe: '副标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'itemGap',
                describe: '主副标题之间的间距。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 69,
                name: 'left',
                describe: '标题左侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 70,
                name: 'right',
                describe: '标题右侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 71,
                name: 'top',
                describe: '标题顶部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 72,
                name: 'bottom',
                describe: '标题底部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 73,
                name: 'offset',
                describe: '标题偏移量',
                type: 'Array',
                defVal: '[0, -20]',
                state: '',
                remarks: '用于设置标题相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
            },
            {
                key: 2,
                name: 'textStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 21,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#333",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 22,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "18",
                        remarks: '',
                    },
                    {
                        key: 23,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 25,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 74,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 75,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            },
            {
                key: 3,
                name: 'subtextStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 31,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#aaa",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 32,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "12",
                        remarks: '',
                    },
                    {
                        key: 33,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 35,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 76,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 77,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            }
        ],
        remarks: '详细默认值请查看title属性讲解',
    },
    {
        name: 'legend',
        describe: '图例样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看legend属性讲解',
    },
    {
        name: 'tooltip',
        describe: '提示层样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看tooltip属性讲解',
    },
    {
        name: 'xAxis',
        describe: 'X轴样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        must: true,
        remarks: '详细默认值请查看xAxis属性讲解',
    },
    {
        name: 'yAxis',
        describe: 'Y轴样式与功能配置',
        type: 'Object | Object[]',
        defVal: "{ ... }",
        state: '',
        remarks: '详细默认值请查看yAxis属性讲解，已支持多条y轴功能。',
    },
    {
        name: 'dataZoom',
        describe: 'dataZoom 组件 用于区域缩放，从而能自由关注细节的数据信息。',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看dataZoom属性讲解',
    },
    {
        name: 'animation',
        describe: '是否开启动画。',
        type: 'Boolean',
        defVal: "true",
        state: '',
        remarks: '如果频繁更新数据建议将该属性设置为false',
    },
    {
        name: 'series',
        describe: '柱状区域样式与功能配置',
        type: 'Object[]',
        defVal: "[ ... ]",
        must: true,
        remarks: '详细默认值请查看series属性讲解',
    }
];

const legendData = [
    {
        name: 'show',
        describe: '控制图例显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'orient',
        describe: '图例的方向',
        type: 'String',
        defVal: "'horizontal'",
        state: '',
        remarks: '可以设置为 "horizontal" 或 "vertical"，分别表示水平和垂直方向。'
    },
    {
        name: 'left',
        describe: '图例距离左侧位置',
        type: 'String|Number',
        defVal: 'auto',
        remarks: '',
    },
    {
        name: 'top',
        describe: '图例距离顶部位置',
        type: 'String|Number',
        defVal: '6%',
        remarks: '',
    },
    {
        name: 'right',
        describe: '图例距离右侧位置',
        type: 'String|Number',
        defVal: 'auto',
        state: '',
        remarks: '',
    },
    {
        name: 'bottom',
        describe: '图例距离底部位置',
        type: 'String|Number',
        defVal: 'auto',
        state: '',
        remarks: '',
    },
    {
        name: 'icon',
        describe: '图例项的icon',
        type: 'String',
        defVal: "'roundRect'",
        state: '',
        remarks: '可以设置为 "rect"、"circle" 或 "roundRect"，分别表示矩形、圆形和圆角矩形。'
    },
    {
        name: 'iconRadian',
        describe: '图例项的icon的圆角，只针对icon为roundRect',
        type: 'Number',
        defVal: '2',
        state: '',
        remarks: '当icon设置为 "roundRect" 时，此属性用于设置圆角的半径。'
    },
    {
        name: 'itemGap',
        describe: '每项图例之间的间隔',
        type: 'Number',
        defVal: '10',
        remarks: '',
    },
    {
        name: 'itemTextGap',
        describe: '图形与文本的距离',
        type: 'Number',
        defVal: "5",
        remarks: '',
    },
    {
        name: 'itemWidth',
        describe: '图形的宽度',
        type: 'Number',
        defVal: "16",
        remarks: '',
    },
    {
        name: 'itemHeight',
        describe: '图形的高度',
        type: 'Number',
        defVal: "8",
        remarks: '',
    },
    {
        name: 'align',
        describe: '图例标记和文本的对齐。纵向布局的图例标记和文本的对齐。默认自动，根据组件的位置和 orient 决定，当组件的 left 值为 \'right\' 以及纵向布局（orient 为 \'vertical\'）的时候为右对齐，即为 \'right\'',
        type: 'String',
        defVal: "'auto'",
        state: '',
        remarks: '可以设置为 "left" 或 "right"，分别表示左对齐和右对齐。'
    },
    {
        name: 'selectAble',
        describe: '图例项是否可选',
        type: 'Boolean',
        defVal: 'true',
        state: '',
        remarks: '设置为 true 时，用户可以通过点击图例项来选择或取消选择相应的数据系列。'
    },
    {
        key: 52,
        name: 'textUnselectedStyle',
        describe: '图例未选中状态的文字默认样式配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '用于设置图例未选中状态下文字的样式，如颜色、字体大小等。',
        children: [
            {
                key: 521,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: ''
            },
            {
                key: 522,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "30",
                remarks: ''
            },
            {
                key: 523,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#999",
                remarks: '支持RGB、RGBA、十六进制格式'
            }
        ]
    },
    {
        key: 53,
        name: 'iconUnselectedStyle',
        describe: '图例未选中状态的图标默认样式配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '用于设置图例未选中状态下图标的颜色样式。',
        children: [
            {
                key: 531,
                name: 'color',
                describe: '图标颜色',
                type: 'String',
                defVal: "#999",
                remarks: '支持RGB、RGBA、十六进制格式'
            }
        ]
    },
    {
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "30",
                remarks: '',
            },
            {
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const tooltipData = [
    {
        name: 'show',
        describe: '控制提示层显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'type',
        describe: '提示层显示类型',
        type: 'String',
        defVal: 'default',
        remarks: '可选值：default（默认）、custom（自定义）。需要注意是自定义需要配合监控点击方法回调，通过回调信息自行显示内容与位置',
    },
    {
        key: 1,
        name: 'axisPointer',
        describe: '指示器配置项',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 11,
                name: 'type',
                describe: '指示器类型',
                type: 'String',
                defVal: "line",
                remarks: '可选值：line（线）。目前只支持一种',
            },
            {
                key: 12,
                name: 'lineStyle',
                describe: '提示线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 121,
                        name: 'type',
                        describe: '线类型',
                        type: 'String',
                        defVal: "solid",
                        remarks: '可选值：solid（实线）',
                    },
                    {
                        key: 122,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 123,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        name: 'backgroundColor',
        describe: '提示框背景颜色',
        type: 'String',
        defVal: 'rgba(50,50,50,0.7)',
        remarks: '',
    },
    {
        name: 'borderColor',
        describe: '提示框边框颜色',
        type: 'String',
        defVal: "#333",
        remarks: '',
    },
    {
        name: 'borderWidth',
        describe: '提示框边框宽度',
        type: 'Number',
        defVal: "0",
        remarks: '',
    },
    {
        name: 'padding',
        describe: '提示框内边距',
        type: 'Number',
        defVal: "10",
        remarks: '',
    },
    {
        key: 2,
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 21,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 22,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 23,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 25,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];

const xAxisData = [
    {
        name: 'name',
        describe: 'Y轴线名称',
        type: 'String',
        defVal: "",
        remarks: '',
    },
    {
        name: 'nameGap',
        describe: '坐标轴名称与轴线之间的距离。',
        type: 'Number',
        defVal: "5",
        remarks: '',
    },
    {
        name: 'nameLocation',
        describe: '名称位置',
        type: 'String',
        defVal: "end",
        state: '',
        remarks: "可选值：'end'(尾部) | 'center'(中间) | 'start'(头部)",
    },
    {
        key: 4,
        name: 'nameTextStyle',
        describe: 'Y轴名称样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 41,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#999999",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 42,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "22",
                remarks: '',
            },
            {
                key: 43,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 45,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    },
    {
        key: 1,
        name: 'axisLine',
        describe: 'Y轴线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 11,
                name: 'show',
                describe: '控制轴线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 12,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 121,
                        name: 'type',
                        describe: '线类型',
                        type: 'String',
                        defVal: "solid",
                        remarks: '可选值：solid（实线）',
                    },
                    {
                        key: 122,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 123,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 2,
        name: 'axisTick',
        describe: '刻度线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 21,
                name: 'show',
                describe: '控制刻度线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 22,
                name: 'interval',
                describe: '刻度线与文本的间隔',
                type: 'Number',
                defVal: "4",
                remarks: '',
            },
            {
                key: 23,
                name: 'length',
                describe: '刻度线的长度',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 24,
                name: 'lineStyle',
                describe: '刻度线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 242,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 243,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 3,
        name: 'axisLabel',
        describe: '文本标签样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 31,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 32,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 33,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 35,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            },
            {
                key: 36,
                name: 'interval',
                describe: '强制设置坐标轴分割间隔。',
                type: 'Number',
                defVal: "0",
                remarks: '',
            },
            {
                key: 37,
                name: 'margin',
                describe: '刻度标签与轴线之间的距离。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 39,
                name: 'rotate',
                describe: '轴标签文本旋转角度。',
                type: 'Number',
                defVal: "0",
                state: '',
                remarks: '',
            },
            {
                key: 38,
                name: 'overflow',
                describe: '文字超出宽度是否截断或者换行。',
                type: 'String',
                defVal: "none",
                remarks: '可选值："none"(无)、"truncate"(截断)、"breakAll"(换行)。可搭配width使用'
            },
            {
                key: 40,
                name: 'width',
                describe: '轴标签文本宽度，可以用配置长度超出的处理',
                type: 'Number',
                defVal: "null",
                state: '',
                remarks: ''
            },
            {
                key: 42,
                name: 'formatter',
                describe: '文本内容自定义函数',
                type: 'String | Function',
                defVal: 'null',
                state: '',
                remarks: '支持回调函数返回当前文本内容，需要函数体return对应的值，比如：(name, index) => {return String}。同时也支持字符串模版，比如：{value}件。',
            },
            {
                key: 43,
                name: "shadowColor",
                describe: "轴标签阴影颜色",
                type: "String",
                defVal: "'rgba(0, 0, 0, 0)'",
                state: "new",
                remarks: "使用rgba格式指定颜色及透明度，默认为完全透明。"
            },
            {
                key: 44,
                name: "shadowBlur",
                describe: "轴标签阴影大小",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "控制阴影的模糊程度，值越大，阴影边缘越模糊。"
            },
            {
                key: 45,
                name: "shadowOffsetX",
                describe: "轴标签阴影X轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向右偏移，负值表示向左偏移。"
            },
            {
                key: 46,
                name: "shadowOffsetY",
                describe: "轴标签阴影Y轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向下偏移，负值表示向上偏移。"
            }
        ]
    },
    {
        key: 5,
        name: 'splitLine',
        describe: '分割线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        state: '',
        children: [
            {
                key: 51,
                name: 'show',
                describe: '控制分割线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 52,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 522,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 523,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#DDE2EB",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        name: 'formatter',
        describe: '文本内容自定义函数',
        type: 'Function',
        defVal: 'null',
        state: 'del',
        remarks: '该方法已经迁移到axisLabel中，请重新配置',
    },
    {
        name: 'data',
        describe: 'X轴数据',
        type: '<String|Number>[]',
        defVal: '[]',
        must: true,
        remarks: '',
    },
];

const yAxisData = [
    {
        name: 'name',
        describe: 'X轴线名称',
        type: 'String',
        state: '',
        defVal: "",
        remarks: '',
    },
    {
        name: 'nameGap',
        describe: '坐标轴名称与轴线之间的距离。',
        type: 'Number',
        defVal: "5",
        state: '',
        remarks: '',
    },
    {
        name: 'nameLocation',
        describe: '名称位置',
        type: 'String',
        defVal: "end",
        state: '',
        remarks: "可选值：'end'(尾部) | 'center'(中间) | 'start'(头部)",
    },
    {
        key: 4,
        name: 'nameTextStyle',
        describe: 'X轴名称样式配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '',
        children: [
            {
                key: 41,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#999",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 42,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "22",
                remarks: '',
            },
            {
                key: 43,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 45,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    },
    {
        name: 'position',
        describe: '轴位置',
        type: 'String',
        defVal: "'left'",
        state: '',
        remarks: '当有两条y轴时，可以设置为 "left" 或 "right"，分别表示轴在左侧或右侧。'
    },
    {
        key: 1,
        name: 'axisLine',
        describe: 'X轴线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 11,
                name: 'show',
                describe: '控制轴线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 12,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 121,
                        name: 'type',
                        describe: '线类型',
                        type: 'String',
                        defVal: "solid",
                        remarks: '可选值：solid（实线）',
                    },
                    {
                        key: 122,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 123,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 2,
        name: 'axisTick',
        describe: '刻度线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        children: [
            {
                key: 21,
                name: 'show',
                describe: '控制刻度线显示与隐藏',
                type: 'Boolean',
                defVal: "true",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 22,
                name: 'interval',
                describe: '刻度线与文本的间隔',
                type: 'Number',
                defVal: "4",
                remarks: '',
            },
            {
                key: 23,
                name: 'length',
                describe: '刻度线的长度',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 24,
                name: 'lineStyle',
                describe: '刻度线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 242,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 243,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#555",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        key: 3,
        name: 'axisLabel',
        describe: 'X轴文本标签样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 31,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 32,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 33,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 35,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            },
            {
                key: 36,
                name: 'interval',
                describe: '强制设置坐标轴分割间隔。',
                type: 'Number',
                defVal: "auto",
                remarks: '如果不想要x轴间隔显示，可以直接设置为0',
            },
            {
                key: 37,
                name: 'margin',
                describe: '刻度标签与轴线之间的距离。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 39,
                name: 'rotate',
                describe: '轴标签文本旋转角度。',
                type: 'Number',
                defVal: "0",
                state: '',
                remarks: '',
            },
            {
                key: 38,
                name: 'overflow',
                describe: '文字超出宽度是否截断或者换行。',
                type: 'String',
                defVal: "none",
                remarks: '可选值："none"(无)、"truncate"(截断)、"breakAll"(换行)。可搭配width使用'
            },
            {
                key: 40,
                name: 'width',
                describe: '轴标签文本宽度，可以用配置长度超出的处理',
                type: 'Number',
                defVal: "null",
                state: '',
                remarks: ''
            },
            {
                key: 42,
                name: 'formatter',
                describe: '文本内容自定义函数',
                type: 'String | Function',
                defVal: 'null',
                state: '',
                remarks: '支持回调函数返回当前文本内容，需要函数体return对应的值，比如：(name, index) => {return String}。同时也支持字符串模版，比如：{value}件。',
            },
            {
                key: 43,
                name: "shadowColor",
                describe: "轴标签阴影颜色",
                type: "String",
                defVal: "'rgba(0, 0, 0, 0)'",
                state: "new",
                remarks: "使用rgba格式指定颜色及透明度，默认为完全透明。"
            },
            {
                key: 44,
                name: "shadowBlur",
                describe: "轴标签阴影大小",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "控制阴影的模糊程度，值越大，阴影边缘越模糊。"
            },
            {
                key: 45,
                name: "shadowOffsetX",
                describe: "轴标签阴影X轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向右偏移，负值表示向左偏移。"
            },
            {
                key: 46,
                name: "shadowOffsetY",
                describe: "轴标签阴影Y轴方向的偏移",
                type: "Number",
                defVal: "0",
                state: "new",
                remarks: "正值表示向下偏移，负值表示向上偏移。"
            }
        ]
    },
    {
        key: 5,
        name: 'splitLine',
        describe: 'X轴分割线配置',
        type: 'Object',
        defVal: '{ ... }',
        remarks: '',
        state: '',
        children: [
            {
                key: 51,
                name: 'show',
                describe: '控制分割线显示与隐藏',
                type: 'Boolean',
                defVal: "false",
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                key: 52,
                name: 'lineStyle',
                describe: '轴线样式',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 522,
                        name: 'width',
                        describe: '线宽度',
                        type: 'Number',
                        defVal: "1",
                        remarks: '',
                    },
                    {
                        key: 523,
                        name: 'color',
                        describe: '线颜色',
                        type: 'String',
                        defVal: "#DDE2EB",
                        remarks: '',
                    }
                ]
            }
        ]
    },
    {
        name: 'formatter',
        describe: '文本内容自定义函数',
        type: 'Function',
        defVal: 'null',
        state: 'del',
        remarks: '该方法已经迁移到axisLabel中，请重新配置',
    },
    {
        name: 'boundaryGap',
        describe: '坐标轴两边是否留白策略',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(是)、false(否)',
    },
    {
        name: 'data',
        describe: 'X轴数据',
        type: '<String|Number>[]',
        defVal: '[]',
        must: true,
        remarks: '',
    },
];

const seriesData = [
    {
    name: 'name',
    describe: '系列名称，用于tooltip的显示，legend 的图例筛选',
    type: 'String',
    defVal: "空",
    must: true,
    remarks: '',
}, {
    name: 'color', describe: '系列颜色', type: 'String', defVal: "空", remarks: '',
}, {
    name: 'shapeType',
    describe: '柱状图形状类型',
    type: 'String',
    defVal: "'normal'",
    state: '',
    remarks: '可以设置为 "normal"、"leftEchelon" 或 "rightEchelon"，分别表示普通柱状图、左阶梯状柱状图和右阶梯状柱状图。'
}, {
    key: 62,
    name: 'echelonOffset',
    describe: '阶梯状柱状图锐度偏移量',
    type: 'Number',
    defVal: '10',
    state: '',
    remarks: '用于设置阶梯状柱状图的锐度偏移量。'
}, {
    key: 64,
    name: 'yAxisIndex',
    describe: '线条的Y轴索引',
    type: 'Number',
    defVal: '0',
    state: '',
    remarks: '可以设置为 0 或 1，表示线条对应哪个Y轴。'
}, {
    key: 4, name: 'barStyle', describe: '柱状样式配置', type: 'Object', defVal: "{ ... }", remarks: '', children: [{
        key: 42, name: 'width', describe: '柱子宽度', type: 'Number|string', defVal: "'auto'", remarks: '',
    }, {
        key: 43,
        name: 'color',
        describe: '柱子颜色',
        type: 'String|Array<String>',
        defVal: "空",
        state: '',
        remarks: '可以传入数组作为多色渐变',
    }, {
        key: 44, name: 'barGap', describe: '同系列之间的柱子间隙', type: 'Number|String', defVal: "'30%'", remarks: '',
    }, {
        key: 45,
        name: 'borderRadius',
        describe: '是否显示圆角半径',
        type: 'Boolean | Number | Number[]',
        defVal: "false",
        remarks: 'Boolean类型可选值：true(显示)、false(隐藏)。也可以直接传递数值.还支持传递数组, 数组的规则[左,上,右,下]四个方向',
    }, {
        key: 68,
        name: 'barCategoryGap',
        describe: '柱状图分类间隙',
        type: 'String | Number',
        defVal: "'20%'",
        state: '',
        remarks: '此属性应设置在该坐标系下的最后一个 "bar" 类型序列上才能生效，并且将对这个坐标系下的所有 "bar" 类型序列生效。可以设置为百分比或具体数值。'
    }, {
        key: 69,
        name: 'stroke',
        describe: '柱状图边框颜色',
        type: 'String',
        defVal: "空",
        state: '',
        remarks: '设置柱状图边框的颜色。支持RGB、RGBA、十六进制格式。'
    }]
}, {
    key: 65,
    name: 'backgroundStyle',
    describe: '背景柱状图配置',
    type: 'Object',
    defVal: "{ ... }",
    state: '',
    remarks: '用于配置背景柱状图的显示、宽度和颜色。',
    children: [{
        key: 651,
        name: 'show',
        describe: '是否显示背景柱状图',
        type: 'Boolean',
        defVal: 'false',
        remarks: '设置为 true 时，显示背景柱状图。'
    }, {
        key: 652,
        name: 'width',
        describe: '背景柱状图宽度',
        type: 'String | Number',
        defVal: "'auto'",
        remarks: '可以设置为 "auto"、百分比或具体数值。'
    }, {
        key: 653,
        name: 'color',
        describe: '背景柱状颜色',
        type: 'String',
        defVal: "'rgba(180, 180, 180, 0.2)'",
        remarks: '支持RGB、RGBA、十六进制格式。'
    }]
}, {
    key: 3,
    name: 'label',
    describe: '系列文本标签样式配置',
    type: 'Object',
    defVal: "{ ... }",
    remarks: '',
    children: [{
        key: 30,
        name: 'show',
        describe: '控制文本标签显示与隐藏',
        type: 'Boolean',
        defVal: "true",
        remarks: '可选值：true(显示)、false(隐藏)',
    }, {
        key: 31,
        name: 'color',
        describe: '字体颜色',
        type: 'String',
        defVal: "'#999'",
        remarks: '支持RGB、RGBA、十六进制格式',
    }, {
        key: 32, name: 'fontSize', describe: '字体大小', type: 'Number', defVal: "24", remarks: '',
    }, {
        key: 33, name: 'fontWeight', describe: '字体粗细', type: 'String', defVal: "normal", remarks: '',
    }, {
        key: 35, name: 'fontFamily', describe: '字体样式', type: 'String', defVal: "sans-serif", remarks: '',
    }, {
        key: 68,
        name: 'formatter',
        describe: '线条标签格式化',
        type: 'String | Function',
        defVal: 'null',
        state: '',
        remarks: '支持字符串模板和回调函数。例如，可以设置为 "{value}件" 或 (dataItem) => (dataItem.value)。'
    }, {
        key: 66,
        name: 'position',
        describe: '线条标签位置',
        type: 'String',
        defVal: "'top'",
        state: '',
        remarks: '可以设置为 "top"、"center" 或 "bottom"，分别表示标签在顶部、中间或底部。'
    }, {
        key: 67,
        name: 'offset',
        describe: '线条标签偏移量',
        type: 'Array',
        defVal: '[0, -10]',
        state: '',
        remarks: '用于设置标签相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
    }]
}, {
    name: 'stack', describe: '是否显示堆叠柱子', type: 'String', defVal: '空', remarks: '设置相同名称的会被堆叠计算'
}, {
    key: 56,
    name: 'data',
    describe: '柱状图数据',
    type: 'Array<String|Number|Object>',
    defVal: '[]',
    state: '',
    must: true,
    remarks: '可以包含数值或对象，例如 [100, 200, {value: 100, color: xxx}]。'
}];

const anchorItems = [
    {
        key: '1',
        href: '#xAxis',
        title: 'xAxis属性',
    },
    {
        key: '2',
        href: '#yAxis',
        title: 'yAxis属性',
    },
    {
        key: '3',
        href: '#legend',
        title: 'legend属性'
    },
    {
        key: '4',
        href: '#tooltip',
        title: 'tooltip属性'
    },
    {
        key: '5',
        href: '#dataZoom',
        title: 'dataZoom属性'
    },
    {
        key: '6',
        href: '#series',
        title: 'series属性'
    },
    {
        key: '7',
        href: '#seriesGradient',
        title: '渐变模式'
    },
    {
        key: '8',
        href: '#seriesRadius',
        title: '圆角模式'
    },
    {
        key: '9',
        href: '#seriesStack',
        title: '堆叠模式'
    }
]

const dataZoomData = [
    {
        name: 'show',
        describe: '是否开启区域滚动',
        type: 'Boolean',
        defVal: "false",
        remarks: '可选值：true(启动)、false(关闭)',
    },
    {
        name: 'start',
        describe: '滚动开始节点。',
        type: 'Number',
        defVal: "0",
        remarks: '',
    },
    {
        name: 'end',
        describe: '滚动结束节点。',
        type: 'Number',
        defVal: "6",
        remarks: '',
    }
];

export {
    defCode,
    changeCode,
    xAxisCode,
    yAxisCode,
    legendCode,
    tooltipCode,
    tooltipCustomCode,
    dataZoomCode,
    seriesCode,
    seriesGradientOption,
    seriesRadiusOption,
    stackSeriesOption,
    columns,
    commonData,
    legendData,
    tooltipData,
    xAxisData,
    yAxisData,
    dataZoomData,
    seriesData,
    anchorItems
}
